import { render, staticRenderFns } from "./headerBackground.vue?vue&type=template&id=406dee34&scoped=true"
import script from "./headerBackground.vue?vue&type=script&lang=ts"
export * from "./headerBackground.vue?vue&type=script&lang=ts"
import style0 from "./headerBackground.vue?vue&type=style&index=0&id=406dee34&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406dee34",
  null
  
)

export default component.exports